<template>
  <Page class="queryView">
    <div class="queryView-main">
      <div style="display:flex;width:100%">
        <a-form class="flex-form" style="flex: 1" layout="inline" :form="form" :colon="false">
          <div class="grid grid-cols-2 xl:grid-cols-3">
            <a-form-item label="所属城市">
              <a-input v-decorator="['region']"></a-input>
            </a-form-item>
            <a-form-item label="景点名称">
              <a-input v-decorator="['name']"></a-input>
            </a-form-item>
          </div>
        </a-form>
        <div style="text-align: right">
        <a-button class="app-btn"
                    type="primary"
                    @click="doQuery(1)">立即搜索</a-button>
          <a-button class="app-btn"
                    type="default"
                    @click="resetAndQuery$qv" style="margin-left: 10px;">重置搜索</a-button>
          <a-button class="app-btn" type="default" @click="handleAdd" style="margin-left: 30px;">添加景点</a-button>
        </div>
      </div>

      <a-table
        class="mt-5"
        :row-key="
          (record, index) => {
            return index
          }
        "
        bordered
        :loading="tableLoading"
        :columns="tableColumns"
        :dataSource="dataSource"
        @change="handleTableChange$qv"
        :scroll="{ x: 1400 }"
        :pagination="{
          current: pageNumber,
          pageSize: limit,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }"
      />
    </div>
    <a-modal :visible="addGuideType" :title="modalTitle" @ok="submit" width="700px" @cancel="handleCancel">
      <div>
        <a-form :form="addForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <a-form-item label="所属区域">
                <a-input v-decorator="['region', { rules: [{ required: true, message: '请输入所属区域' }] }]" />
              </a-form-item>
            </el-col>
            <el-col :span="12">
              <a-form-item label="景点名称">
                <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入景点名称' }] }]" />
              </a-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <a-form-item label="旺季全价">
                <a-input
                  type="number"
                  v-decorator="['peakPriceFull', { rules: [{ required: true, message: '请输入旺季全价' }] }]"
                />
              </a-form-item>
            </el-col>
            <el-col :span="12">
              <a-form-item label="旺季半价">
                <a-input type="number" v-decorator="['peakPriceHalf', { rules: [{ required: true, message: '请输入旺季半价' }] }]" />
              </a-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <a-form-item label="旺季学生">
                <a-input
                  type="number"
                  v-decorator="['peakStudent', { rules: [{ required: true, message: '请输入旺季学生' }] }]"
                />
              </a-form-item>
            </el-col>
            <el-col :span="12">
              <a-form-item label="旺季老人">
                <a-input type="number" v-decorator="['peakOld', { rules: [{ required: true, message: '请输入旺季老人' }] }]" />
              </a-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <a-form-item label="旺季免票">
                <a-input
                  type="number"
                  v-decorator="['peakFree', { rules: [{ required: true, message: '请输入旺季免票' }] }]"
                />
              </a-form-item>
            </el-col>
            <el-col :span="12">
              <a-form-item label="淡季全价">
                <a-input type="number" v-decorator="['offPeakPriceFull', { rules: [{ required: true, message: '请输入淡季全价' }] }]" />
              </a-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <a-form-item type="number" label="淡季半价">
                <a-input v-decorator="['offPeakPriceHalf', { rules: [{ required: true, message: '请输入淡季半价' }] }]" />
              </a-form-item>
            </el-col>
            <el-col :span="12">
              <a-form-item type="number" label="淡季学生">
                <a-input v-decorator="['offPeakStudent', { rules: [{ required: true, message: '请输入淡季学生' }] }]" />
              </a-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <a-form-item type="number" label="淡季老人">
                <a-input v-decorator="['offPeakOld', { rules: [{ required: true, message: '请输入淡季老人' }] }]" />
              </a-form-item>
            </el-col>
            <el-col :span="12">
              <a-form-item type="number" label="淡季免票">
                <a-input v-decorator="['offPeakFree', { rules: [{ required: true, message: '请输入旺季免票' }] }]" />
              </a-form-item>
            </el-col>
          </el-row>
        </a-form>
      </div>
    </a-modal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.limit * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '所属区域',
        align: 'center',
        dataIndex: 'region',
      },
      {
        title: '景点名称',
        align: 'center',
        dataIndex: 'name',
      },
      {
        title: '旺季全价',
        align: 'center',
        dataIndex: 'peakPriceFull'
      },
      {
        title: '旺季半价',
        align: 'center',
        dataIndex: 'peakPriceHalf'
      },
      {
        title: '旺季学生',
        align: 'center',
        dataIndex: 'peakStudent'
      },
      {
        title: '旺季老人',
        align: 'center',
        dataIndex: 'peakOld'
      },
      {
        title: '淡季全价',
        align: 'center',
        dataIndex: 'offPeakPriceFull'
      },
      {
        title: '淡季半价',
        align: 'center',
        dataIndex: 'offPeakPriceHalf'
      },
      {
        title: '淡季学生',
        align: 'center',
        dataIndex: 'offPeakStudent'
      },
      {
        title: '淡季老人',
        align: 'center',
        dataIndex: 'offPeakOld'
      },
      {
        title: '操作',
        width: '12%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex justify-center gap-5 text-primary-500">
              <a
                class="text-primary-500"
                onClick={() => {
                  this.checkRow(row, 'edit')
                }}
              >
                修改
              </a>
              <a
                onClick={() => {
                  this.handleDel(row)
                }}
              >
                删除
              </a>
            </div>
          )
        },
      },
    ]
    return {
      modalTitle: '添加景点',
      // labelCol: { style: { width: '100px' } },
      pageNumber: 1,
      limit: 10,
      countTotal: 0,
      id: null,
      tableLoading: false,
      addGuideType: false,
      tableColumns: tableColumns,
      dataSource: [],
      form: this.$form.createForm(this),
      addForm: this.$form.createForm(this),
      typeList: [
        { label: 'API', value: 1 },
        { label: 'H5', value: 2 },
        { label: '小程序', value: 3 },
      ],
    }
  },
  components: {
    Page,
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    submit() {
      this.addForm.validateFields(async (err, values) => {
        if (!err) {
          const params = values
          params.id = this.id
          let res = null
          if (this.modalTitle == '添加景点') {
            res = await this.$axios.post('/guide/admin/scenicSpot/add', params)
          } else {
            res = await this.$axios.put('/guide/admin/scenicSpot/edit', params)
          }
          console.info('success', res)
          if (res && res.success) {
            this.addGuideType = false
            this.doQuery()
          }
        }
      })
    },
    handleCancel() {
      this.addGuideType = false
    },
    async doQuery(_page = this.pageNumber, _limit = this.limit) {
      this.tableLoading = true
      const res = await this.$axios.get('/guide/admin/scenicSpot/getList', {
        params: {
          page: _page,
          limit: _limit,
          ...this.form.getFieldsValue(),
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    async handleAdd() {
      this.modalTitle = '添加景点'
      this.id = null
      this.addForm.resetFields()
      this.addGuideType = true
    },
    async checkRow(row) {
      this.modalTitle = '编辑景点'
      this.id = row.id
      const res = await this.$axios.get(`/guide/admin/scenicSpot/get/${row.id}`)
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.addForm, res.data)
      })
      this.addGuideType = true
    },
    async handleDel(row) {
      this.$confirm({
        title: '删除确认',
        content: '您确认删除当前景点?',
        onOk: async () => {
          const res = await this.$axios.delete(`/guide/admin/scenicSpot/delete/${row.id}`)
          if (res.success) {
            this.$message.success('删除成功')
            this.doQuery()
          }
        },
        onCancel: () => {
          // reject(new Error('E_CANCEL'))
        },
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
